import "./sidebarprofile.scss";
import React from "react";
import Rectangle from "../Rectangle/rectangle";

function SidebarProfile(props) {
  const { profile } = props;

  return (
    <div className="sidebar-profile">
      <div className="profile-container">
        <div className="profile-container-info">
          <div className="profile-user-name">
            <span className="texts"> {profile?.name} </span>
            {profile?.subscription?.plan === `Free` && profile?.subscription?.active && (
              <div className="current-plan-info">
                <Rectangle className="free-badge" title={`Free`} />
              </div>
            )}
          </div>
          <small className="texts" style={{ fontSize: 12 }}>
            {profile?.email}
          </small>
        </div>
      </div>
    </div>
  );
}

export default SidebarProfile;
